import { css, utilities } from "@creditas/stylitas";

export const getColor = (color: string) => ({ theme }) => {
  return css`
    ${utilities.palette.color(theme, color)}
  `;
};
